<template src='./tabClassification.pug' lang='pug'></template>

<script>
import vSelect from 'vue-select'
import ButtonPrimary from '../../../buttons/buttonPrimary/ButtonPrimary'
import axios from '../../../../../build/http-requests/axios-common.js'
import customSorter from '../../../../utils/customSorter.js'

export default {
  name: 'TabClassification',

  components: {
    vSelect,
    ButtonPrimary
  },

  props: {
    idModal: {
      type: String
    },
    mainValuesList: {
      type: Array,
      required: true
    }
  },

  data () {
    return {
      bankMov: {
        id: null,
        situacaoConciliacao: 'A',
        planoConciliacao: null,
        categoria: null,
        estabelecimento: null,
        contaLancamento: {
          id: null
        }
      },
      categories: [],
      establishments: [],
      conciliationPlans: [],
      isLoadingData: true,
      valuesList: []
    }
  },

  computed: {
    titleFormClassif () {
      return this.$t('modalDetalhesLanc.titulos.tabClassif')
    },

    conciliationPlansLenght () {
      return this.conciliationPlans.length <= 1
    },

    existsConciliationPlans () {
      return this.conciliationPlans.length !== 0
    },

    enableRemove () {
      return this.bankMov.id && this.bankMov.situacaoConciliacao === 'A'
    },

    defineClassificationLabel () {
      let label = ''
      if (this.bankMov.critClassif && this.bankMov.critClassif.toLowerCase() !== this.$t('modalDetalhesLanc.tabClassif.semClassif').toLowerCase()) {
        label = this.bankMov.critClassif
      } else {
        label = this.bankMov.categoria ? this.$t('modalDetalhesLanc.tabClassif.classifManual') : this.$t('modalDetalhesLanc.tabClassif.semClassif')
      }
      return label
    }
  },

  methods: {
    closeModal () {
      $('#' + this.idModal).modal('hide')
    },

    prepareTab () {
      this.isLoadingData = true
      this.bankMov.contaLancamento.id = this.mainValuesList[0].value
      let critClassif = this.mainValuesList.filter(item => item.title === this.$t('modalDetalhesLanc.tabClassif.critClassif'))
      let labelClassif = critClassif && critClassif.length > 0 ? critClassif[0].value : null
      this.valuesList = this.mainValuesList.filter(item => item.title !== this.$t('modalDetalhesLanc.tabClassif.critClassif'))

      return new Promise((resolve, reject) => {
        axios.get('/bankStatement/getBankMovmentByIdBankStatment', { params: { idContaLancamento: this.mainValuesList[0].value } }).then((responseMov) => {
          this.bankMov = responseMov.data.data
          if (!this.bankMov) {
            this.bankMov = {
              id: null,
              situacaoConciliacao: 'A',
              planoConciliacao: null,
              categoria: null,
              estabelecimento: null,
              contaLancamento: {
                id: this.mainValuesList[0].value
              }
            }
          }
          this.bankMov.critClassif = labelClassif

          if (this.bankMov.planoConciliacao) {
            this.bankMov.planoConciliacao.label = this.bankMov.planoConciliacao.nome
          }

          if (this.bankMov.categoria) {
            this.bankMov.categoria.label = this.bankMov.categoria.numero + ' - ' + this.bankMov.categoria.nome
          }

          if (this.bankMov.estabelecimento) {
            this.bankMov.estabelecimento.label = this.bankMov.estabelecimento.nome + ' - ' + this.bankMov.estabelecimento.cnpj
            this.establishments.push(this.bankMov.estabelecimento)
          }

          this.$store.dispatch('getPlans', '/conciliationPlan/listCategorized').then((responsePlan) => {
            this.conciliationPlans = responsePlan.data
            this.conciliationPlans = this.conciliationPlans.map(plan => {
              plan.label = plan.planName
              return plan
            })
            this.bankMov.planoConciliacao = this.conciliationPlans[0]

            this.$store.dispatch('getCategories', {
              url: '/bankStatement/loadCategories',
              flTipoCategoria: null,
              validarUso: false
            }).then((responseCat) => {
              let catArray = []
              responseCat.data.forEach(cat => {
                cat.label = cat.numero + ' - ' + cat.nome
                catArray.push(cat)
              })
              // arrayDottedSorter ordena o array baseado em valores do tipo '1.1.1'
              this.categories = customSorter.arrayDottedSorter(catArray, 'numero', 'asc')
              this.isLoadingData = false
            }).catch((errorCat) => {
              this.$root.$refs.notification.error(errorCat.data.message)
              this.isLoadingData = false
            })
          }).catch((errorPlan) => {
            this.$root.$refs.notification.error(errorPlan.data.message)
            this.isLoadingData = false
          })
          resolve()
        }).catch((errorMov) => {
          this.$root.$refs.notification.error(errorMov)
          this.isLoadingData = false
          reject()
        })
      })
    },

    loadEstablishments (search = []) {
      if (search.length) {
        const filters = this.mountFilters({
          ascending: 1,
          orderBy: 'nome',
          page: 1,
          limit: 5,
          query: {
            nome: search
          }
        })

        this.$store.dispatch('getEstablishments', filters)
          .then((response) => {
            if (response.elements.length === 0) {
              this.establishments = []
            } else {
              this.establishments = response.elements
            }
          })
          .catch((error) => {
            this.establishments = []
            this.$root.$refs.notification.error(error.message)
          })
      }
    },

    mountFilters (pagination) {
      const filters = {}
      const atributosValores = []
      for (const key in pagination.query) {
        filters[key] = pagination.query[key]
      }
      return {
        atributosValores,
        filters,
        ...pagination,
        url: 'establishment/list'
      }
    },

    handleClearList () {
      this.establishments = []
    },

    bindConciliationPlan (plan) {
      if (plan) {
        this.bankMov.planoConciliacao = plan
        this.errors.remove('bankMov.planoConciliacao')
      }
    },

    validate () {
      this.isLoadingData = true
      let self = this
      let promise = null
      return new Promise(resolve => {
        self.$validator.validateAll().then((result) => {
          if (result) {
            promise = self.createClassification()
            promise.finally(() => {
              resolve()
            })
          } else {
            this.isLoadingData = false
          }
        })
      })
    },

    createClassification () {
      return new Promise((resolve, reject) => {
        axios.post('/bankStatement/saveBankMovment', this.bankMov).then((response) => {
          this.$root.$refs.notification.success(this.enableRemove ? 'movbancaria.sucesso.atualizar' : 'movbancaria.sucesso.salvar')
          this.bankMov = response.data.data
          if (this.bankMov.planoConciliacao) {
            this.bankMov.planoConciliacao.label = this.bankMov.planoConciliacao.nome
          }
          if (this.bankMov.categoria) {
            this.bankMov.categoria.label = this.bankMov.categoria.numero + ' - ' + this.bankMov.categoria.nome
          }
          if (this.bankMov.estabelecimento) {
            this.bankMov.estabelecimento.label = this.bankMov.estabelecimento.nome + ' - ' + this.bankMov.estabelecimento.cnpj
            this.establishments = []
            this.establishments.push(this.bankMov.estabelecimento)
          }
          this.isLoadingData = false
          resolve()
        }).catch((errorMov) => {
          this.$root.$refs.notification.error(errorMov)
          this.isLoadingData = false
          reject()
        })
      })
    },

    remove () {
      this.isLoadingData = true
      return new Promise((resolve, reject) => {
        axios.delete('/bankStatement/deleteBankMovment', { params: { idMovBancario: this.bankMov.id } }).then((response) => {
          this.$root.$refs.notification.success('movbancaria.sucesso.remover')
          this.bankMov = {
            id: null,
            situacaoConciliacao: 'A',
            planoConciliacao: this.conciliationPlans[0],
            categoria: null,
            estabelecimento: null,
            contaLancamento: {
              id: this.mainValuesList[0].value
            }
          }

          this.isLoadingData = false
          resolve()
        }).catch((error) => {
          this.$root.$refs.notification.error(error)
          this.isLoadingData = false
          reject()
        })
      })
    }
  }
}
</script>

<style lang='css' scoped>
.grid-modal-content {
  padding: 5px 10px 0px 10px;
  min-height: 47vh;
  min-width: 47vw;
}

.tab-detail-value {
  font-family: 'Inter', sans-serif;
  font-weight: bold;
  color: #17375f;
  font-size: 15px;
  white-space: pre-wrap;
  overflow-wrap: break-word;
}

.detail-title {
  font-family: 'Inter', sans-serif;
  font-size: 13px;
  margin-top: 1vh;
  color: #17375f;
}

#main-detail-container.main-container {
  max-height: 65vh;
  overflow: auto;
}

.detail-status {
  font-family: 'Inter', sans-serif;
  font-weight: bold;
  font-size: 3vh;
}

.font-C {
  color: #3bb57a;
}

.font-D {
  color: #f55753;
}

.font-N {
  color: #56a9c1;
}

.font-A {
  color: #fdbd39;
}

#tab-details-id {
  margin: 0px;
  overflow: hidden;
  width: 100%;
  font-family: 'Inter', sans-serif;
}

.bordered {
  border: 1px solid  #d0d0d0;
}
</style>



// WEBPACK FOOTER //
// TabClassification.vue?fe067658